var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.allowWorkspacesMigrate && _vm.inProgress)?_c('AxWorkspacesMigrationDialog',{attrs:{"migration-id":_vm.migrationId}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }